export const appName = 'SwapMyFace'
